import * as React from 'react';
import Button from '../button';
const PickerButton = (props) => (React.createElement(Button, { size: "small", type: "primary", ...props }));
export default PickerButton;
